var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestionnaire(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 6H10V9H2V6Z",
    fill: "#00796B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12H12V15H2V12Z",
    fill: "#00796B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 18H15V21H2V18Z",
    fill: "#FFC300"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.731 5.04135C13.254 5.77264 13 6.62689 13 7.5H15.97C15.97 7.20315 16.0564 6.91268 16.2186 6.66406C16.3807 6.41543 16.6118 6.21936 16.8835 6.09973C17.1551 5.9801 17.4558 5.9421 17.7487 5.99035C18.0416 6.0386 18.3141 6.17102 18.5331 6.37146C18.7521 6.57189 18.908 6.83172 18.9819 7.11923C19.0557 7.40673 19.0444 7.70956 18.9492 7.99072C18.854 8.27191 18.679 8.51931 18.4456 8.70278C18.2123 8.88626 17.9306 8.99789 17.6349 9.02404L17.6357 9.03311C16.7051 9.2044 16 10.0198 16 11V15H19V11.7426C19.4603 11.5799 19.8935 11.3425 20.2813 11.0376C20.9677 10.498 21.4822 9.77029 21.7623 8.94329C22.0423 8.11633 22.0757 7.22573 21.8584 6.38009C21.6411 5.53445 21.1825 4.77029 20.5385 4.18075C19.8945 3.59118 19.0929 3.20175 18.2314 3.05984C17.3699 2.91793 16.4857 3.02969 15.6866 3.38156C14.8875 3.73339 14.2081 4.31008 13.731 5.04135Z",
    fill: "#FF6F61"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19 18.5C19 19.3284 18.3284 20 17.5 20C16.6716 20 16 19.3284 16 18.5C16 17.6716 16.6716 17 17.5 17C18.3284 17 19 17.6716 19 18.5Z",
    fill: "#FF6F61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionnaire);
export default __webpack_public_path__ + "static/media/Questionnaire.1e4a6d4587f1b392d0855a6a140d0c1a.svg";
export { ForwardRef as ReactComponent };